//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        billId: {
            type: String,
            default: '',
        },
        layout: {
            type: String,
            default:
                'auditUserName,auditStatus,auditRemark,auditStartTime,auditFinishTime',
        },
    },
    data() {
        return {
            tableData: [],
        };
    },
    watch: {
        billId: {
            handler() {
                if (!this.billId) {
                    return;
                }

                this.queryData();
            },
            immediate: true,
        },
    },
    methods: {
        queryData() {
            this.$get(
                `${this.$store.getters.indexUrl}/settle/settBill/auditTask`,
                {
                    billId: this.billId,
                },
                (data) => {
                    this.tableData = data;
                }
            );
        },
    },
};
